import React from 'react';
import { SideBarItems } from 'components/Sidebar';
import { ReceiptLong, PaymentsOutlined } from '@mui/icons-material';
import { CreditCard } from 'lucide-react';
import { Plan, PaymentHistory } from 'modules/ManagePlan';

export const ModulesMenu: SideBarItems[] = [
  {
    path: "/",
    urlKey: "manage-plan",
    text: "Manage Plan",
    icon: <CreditCard />,
    type: "menuHeader",
    menuKey: "campaignKing",
    requiredRole: "admin",
    dictionaryKey: "sidebar-menu-manage-plan",
    items: [
      {
        path: "/manage-plan/",
        urlKey: "plan",
        text: "Plan",
        icon: <ReceiptLong />,
        type: "menuItem",
        menuKey: "campaignKing",
        module: <Plan />,
        requiredRole: "admin",
        dictionaryKey: "sidebar-menu-manage-plan-plan",
      },
      {
        path: "/manage-plan/",
        urlKey: "payment-history",
        text: "Payment History",
        icon: <PaymentsOutlined />,
        type: "menuItem",
        menuKey: "campaignKing",
        module: <PaymentHistory />,
        requiredRole: "admin",
        dictionaryKey: "sidebar-menu-manage-plan-payment-history",
      },
    ],
  },
  {
    path: "/",
    urlKey: "manage-plan",
    text: "Manage Plan",
    icon: <CreditCard />,
    type: "menuHeader",
    menuKey: "instantUpdate",
    requiredRole: "admin",
    dictionaryKey: "sidebar-menu-manage-plan",
    items: [
      {
        path: "/manage-plan/",
        urlKey: "plan",
        text: "Plan",
        icon: <ReceiptLong />,
        type: "menuItem",
        menuKey: "instantUpdate",
        module: <Plan />,
        requiredRole: "admin",
        dictionaryKey: "sidebar-menu-manage-plan-plan",
      },
      {
        path: "/manage-plan/",
        urlKey: "payment-history",
        text: "Payment History",
        icon: <PaymentsOutlined />,
        type: "menuItem",
        menuKey: "instantUpdate",
        module: <PaymentHistory />,
        requiredRole: "admin",
        dictionaryKey: "sidebar-menu-manage-plan-payment-history",
      },
    ],
  },
];
